import ResizableTextArea from "@Shared/components/inputs/resizable-textarea.vue";
import { computed, defineComponent, toRefs } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import { useApplicationStoreActions, useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import * as ApplicationsActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import * as ApplicationsGetters from "@Broker/@Modules/clients/applications/application/store/lender-submit-getters";
import CommissionsNotesLoader from "./commissions-notes-loader.vue";
export default defineComponent({
  name: "NotesContainer",
  components: {
    ResizableTextArea,
    CommissionsNotesLoader
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    mortgageType: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: 2000
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const {
      tc
    } = useI18n();
    const {
      applicationId,
      mortgageType,
      clientUsername
    } = toRefs(props);
    const {
      GET_COMMISSIONS_NOTE
    } = useApplicationStoreGetters([ApplicationsGetters.GET_COMMISSIONS_NOTE]);
    const {
      UPDATE_COMMISSIONS_DETAILS
    } = useApplicationStoreActions([ApplicationsActions.UPDATE_COMMISSIONS_DETAILS]);
    const handleChange = note => {
      UPDATE_COMMISSIONS_DETAILS({
        applicationId: applicationId.value,
        commissionsDetails: {
          note
        },
        clientUsername: clientUsername.value,
        mortgageType: mortgageType.value
      });
    };
    const note = computed(() => GET_COMMISSIONS_NOTE.value(applicationId.value));
    return {
      handleChange,
      tc,
      note
    };
  }
});